<template>
    <div class="components-container">
        <div class="filter-container">
            <el-select v-model="queryForm.semesterCode" placeholder="学年学期" style="width: 220px" clearable>
                <el-option v-for="(item, index) in comboOption.semester" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-input v-show="!stuAuthVisible" v-model="queryForm.stuCode" @keyup.enter.native="handleFilter" style="width: 180px;" placeholder="学号 / 姓名" clearable></el-input>
            <!-- <el-input v-show="!stuAuthVisible" v-model="queryForm.stuName" @keyup.enter.native="handleFilter" style="width: 180px;" placeholder="姓名" clearable></el-input> -->
            <el-input v-show="!stuAuthVisible" v-model="queryForm.className" @keyup.enter.native="handleFilter" style="width: 180px;" placeholder="班级名称" clearable></el-input>
            <el-select v-model="queryForm.auditState" placeholder="审核状态" style="width: 180px" clearable>
                <el-option v-for="(item, index) in comboOption.auditState" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-button @click="handleFilter" type="gray" style="margin-left: 10px;"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button v-if="stuAuthVisible" @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i>&nbsp;添加</el-button>
        </div>

        <el-table :data="tableData" v-loading.body="tableLoading" element-loading-text="数据加载中" stripe border fit
            :cell-style="handleCellStyle" highlight-current-row style="width:100%;" :height="mainTableHeight" ref="mainTable">
            <el-table-column label="序号" width="60px" align="center">
                <template slot-scope="scope">
                    <span>{{(queryForm.pageNum - 1) * queryForm.rowNum + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column label="学年学期名称" prop="semesterName" align="center" width="200px"></el-table-column>
            <el-table-column label="学号" prop="stuCode" align="center" width="150px"></el-table-column>
            <el-table-column label="姓名" prop="stuName" align="center" width="150px"></el-table-column>
            <el-table-column label="班级名称" prop="className" align="center" width="150px"></el-table-column>
            <el-table-column label="课题名称" prop="projectName" align="center" min-width="20%"></el-table-column>
            <el-table-column label="提交状态" prop="submitState" :formatter="submitStateFormatter" align="center" width="100px"></el-table-column>
            <el-table-column label="审核状态" prop="auditState" :formatter="auditStateFormatter" align="center" width="100px"></el-table-column>
            <el-table-column label="操作" align="center" width="300px">
                <template slot-scope="scope">
                    <el-button v-if="stuAuthVisible && scope.row.submitState=='0'" size="small" @click="editRec(scope.row);" type="warning">
                        <i class="el-icon-edit"></i>&nbsp;编辑
                    </el-button>
                    <el-button v-if="stuAuthVisible && scope.row.submitState=='0'" size="small" @click="delRec(scope.row);" type="danger">
                        <i class="el-icon-delete"></i>&nbsp;删除
                    </el-button>
                    <el-button v-if="(!stuAuthVisible && scope.row.auditAuth=='0') || (stuAuthVisible && scope.row.submitState=='1') " size="small" @click="showRec(scope.row);" type="primary">
                        <i class="el-icon-tickets"></i>&nbsp;详情
                    </el-button>
                    <el-button v-if="scope.row.auditAuth == '1'" size="small" @click="auditRec(scope.row);" type="primary">
                        <i class="el-icon-edit-outline"></i>&nbsp;审核
                    </el-button>
                    <el-button v-if="scope.row.submitState=='1' || scope.row.auditState!=''" size="small" @click="showAuditList(scope.row);">
                        <i class="el-icon-document"></i>&nbsp;审核信息
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="queryForm.pageNum"
                :page-sizes="[10, 20, 50]" :page-size="queryForm.rowNum" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <!-- 新建编辑 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @closed="closeDialog" width="800px" :top="dialogTop" append-to-body>
            <el-form class="small-space" :model="curdForm" :rules="rules" ref="curdForm" label-position="left" label-width="110px" style="width: 100%;">
                <div v-show="operateAreaVisible">
                    <el-row style="margin-bottom:-10px;">
                        <el-col :span="12">
                            <el-form-item label="学号" prop="stuCode">{{ queryForm.stuCode }}</el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="姓名" prop="stuName">{{ queryForm.stuName }}</el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="学年学期" prop="semesterCode">
                        <el-select v-model="curdForm.semesterCode" placeholder="请选择学年学期" style="width:100%;" clearable>
                            <el-option v-for="(item, index) in comboOption.semester" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="课题名称" prop="projectName">
                        <el-input v-model="curdForm.projectName" placeholder="请填写课题名称"></el-input>
                    </el-form-item>
                    <el-form-item label="设计说明" prop="designDesc">
                        <el-input type="textarea" v-model="curdForm.designDesc" placeholder="请填写设计说明" rows="5" maxlength="500" show-word-limit></el-input>
                    </el-form-item>
                </div>
                <div v-if="viewAreaVisible">
                    <el-row style="margin-bottom:-10px;">
                        <el-col :span="12">
                            <el-form-item label="学号">{{ selectRowData ? selectRowData.stuCode : '' }}</el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="姓名">{{ selectRowData ? selectRowData.stuName : '' }}</el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="学年学期">
                        {{ selectRowData ? selectRowData.semesterName : '' }}
                    </el-form-item>
                    <el-form-item label="课题名称">
                        {{ selectRowData ? selectRowData.projectName : '' }}
                    </el-form-item>
                    <el-form-item label="设计说明">
                        <div style="max-height:110px; overflow-y:auto;">
                            {{ selectRowData ? selectRowData.designDesc : '' }}
                        </div>
                    </el-form-item>
                </div>
            </el-form>
            <div v-show="attachmentVisible">
                <el-table :data="fileTableData" v-loading.body="fileTableLoading" element-loading-text="数据加载中"
                    style="width: 100%" :height="fileTableHeight" ref="multipleTable" stripe border fit @row-click="handleRowClick">
                    <el-table-column v-if="operateAreaVisible" type="selection" width="55"></el-table-column>
                    <el-table-column label="文件名" prop="fileName" align="center" min-width="40%"></el-table-column>
                    <el-table-column label="文件类型" prop="fileType" align="center" width="150px"></el-table-column>
                    <el-table-column align="center" width="200">
                        <template slot="header" slot-scope="scope">
                            <div v-show="operateAreaVisible">
                                <el-button size="small" @click="uploadDialogVisible = true" type="success"><i class="el-icon-upload2"></i>&nbsp;上传</el-button>
                                <el-button size="small" @click="confirmDelFile" type="danger"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
                            </div>
                            <div v-if="viewAreaVisible">操作</div>
                        </template>
                        <template slot-scope="scope">
                            <div @click.stop>
                                <el-button size="small" @click="showAttachment(scope.row);" type="primary">
                                    <i class="el-icon-view"></i>&nbsp;预览
                                </el-button>
                                <el-button size="small" @click="downloadAttachment(scope.row);" type="primary">
                                    <i class="el-icon-download"></i>&nbsp;下载
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="auditAreaVisible" style="margin-bottom: -25px;">
                <audit ref="audit" :itemCode="queryForm.itemCode" :relatedCode="selectRowData.id" :auditLevel="selectRowData.auditLevel"
                    @auditCallback="auditCallback"></audit>
            </div>
            <div v-show="operateAreaVisible" slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="formSubmiting" @click="saveRec">保 存</el-button>
                <el-button v-show="submitButtonVisible" type="warning" :loading="formSubmiting" @click="submitRec">提 交</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="附件上传" :visible.sync="uploadDialogVisible" width="520px" style="top:50px;" @close="closeUploadDialog" append-to-body>
            <div class="attachmentUpload" style="width: 100%;">
                <el-upload class="upload-demo" ref="uploadFile" drag action="#" :file-list="fileList" :http-request="getFile"
                    :multiple="multipleType" :auto-upload="false" :limit="10" :on-change="onChangeFile" :on-success="handleFilUploadSuccess"
                    :on-remove="handleRemove" :on-exceed="handleExceed">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        <div style="font-size:16px; font-weight:bold;">将文件拖到此处，或<em>点击上传</em></div>
                        <div style="margin-top:30px; font-size:16px; font-weight:bold;">
                            <el-tooltip placement="top">
                                <div slot="content">
                                    允许上传的文件类型如下（单个文件大小{{ fileSizeLimit }}MB以内）<br/>
                                    文本文件：txt、doc、docx、xls、xlsx、pdf、ppt、pptx<br/>
                                    图片文件：jpg、jpeg、png、gif<br/>
                                    音/视频文件：mp3、mp4
                                </div>
                                <el-button plain>查看上传文件限制</el-button>
                            </el-tooltip>
                        </div>
                    </div>
                </el-upload>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleUpload">确 定</el-button>
                <el-button @click="closeUploadDialog">取 消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="审核信息" :visible.sync="auditListDialogVisible" v-if="auditListDialogVisible" width="900px" top="150px">
            <div style="height:550px;">
                <auditList ref="auditList" :relatedCode="curdForm.id" :listHeight="450"></auditList>
            </div>
        </el-dialog>

        <!-- 文件预览 -->
        <previewer v-if="previewerVisible" ref="previewer" :fileInfo="fileInfo"
            :widthPercent="60" :heightNum="650" :topNum="60"
            @closePreviewer="previewerVisible = false;">
        </previewer>
    </div>
</template>

<script>
    import { globalConfig } from 'static/config'
    import { confirmMsg, showNotify } from 'utils/message';
    import previewer from 'views/file/previewer.vue';
    import audit from 'views/audit/audit.vue';
    import auditList from 'views/audit/auditList.vue';

    export default {
        components: {
            previewer,
            audit,
            auditList,
        },
        data() {
            return {
                stuAuthVisible: false,
                mainTableHeight: 500,
                fileTableHeight: 250,
                dialogVisible: false,
                dialogTitle: null,
                dialogTop: '250px',
                selectRowData: null,
                total: 0,
                tableData: [], //列表数据
                tableLoading: false,
                queryForm: { //查询数据窗口
                    pageNum: 1,
                    rowNum: 10,
                    semesterCode: null,
                    stuCode: null,
                    stuName: null,
                    className: null,
                    auditState: null,
                    itemCode: null,
                },
                comboOption: {
                    semester: null,
                    auditState: null,
                },
                curdForm: {
                    id: null,
                    stuCode: null,
                    semesterCode: null,
                    projectName: null,
                    designDesc: '',
                    submitState: null,
                    auditState: null,
                },
                formSubmiting: false,
                rules: {
                    semesterCode: [{
                            required: true,
                            message: "请选择学年学期",
                            trigger: ["blur", "change"],
                        }
                    ],
                    projectName: [{
                            required: true,
                            message: "课题名称不能为空",
                            trigger: "blur",
                        },
                        {
                            max: 200,
                            message: "长度不得超过50",
                            trigger: "blur",
                        },
                    ],
                },
                saveType: null,
                operateAreaVisible: false,
                viewAreaVisible: false,
                submitButtonVisible: false,
                auditListDialogVisible: false,
                attachmentVisible: false,
                auditAreaVisible: false,
                fileTableData: [],
                fileTableLoading: false,
                uploadDialogVisible: false,
                multipleType: true, //上传 单个/多个文件//file: null, //上传选中的文件
                fileList: [], //上传选中的多个文件
                fileInfo: {
                    name: null,
                    type: null,
                    url: null,
                },
                previewerVisible: false,
                fileName: null,
                fileSizeLimit: 100,
            }
        },
        created(){
			this.init();
        },
        mounted() {
            this.$nextTick(function() {
                //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                };
            });
        },
        methods: {
			init(){
				this.queryUserInfo();
				this.initCombo();
			},
            queryUserInfo() {
                this.$api.system.basic.userInfo({}).then((res) => {
                    const userInfo = res.data.data;

                    if (userInfo) {
                        let roleInfo = userInfo.roles;

                        for (var roleCode in roleInfo) {
                            // console.log("键：" + roleCode + ",值："+ roleInfo[roleCode]);
                            this.userRole = roleInfo[roleCode];
                        }

                        if(this.userRole == '学生'){
                            this.stuAuthVisible = true;
                            this.queryForm.stuCode = userInfo.phone;
                            this.queryForm.stuName = userInfo.name;
                        }else{
                            this.stuAuthVisible = false;
                            // this.queryForm.stuCode = '20215060010101';
                            // this.queryForm.stuName = '何睿';
                        }
                    } else {
                        this.userRole = '访客';
                        this.$router.push('/login');
                    }

                    this.queryAuditParam();
                }).catch((err) => {
                    console.log(err);
                });
            },
            //查询审核调用参数
            queryAuditParam(){
                const pageName = this.$route.path.substring(this.$route.path.lastIndexOf("/")+1);

                this.$api.common.audit.auditParam({
                    data: { pageName: pageName },
                }).then((res) => {
                    this.queryForm.itemCode = res.data.data.auditParam;
                    this.queryList();
                }).catch((err) => {
                    console.log(err);
                });
            },
            initCombo() {
                this.$api.scoreManage.graduateDesign.initCombo().then(response => {
                    this.comboOption.semester = response.data.data.semesterComboData;
                    this.comboOption.auditState = response.data.data.auditStateComboData;
                }).catch(error => {
                    console.log(error);
                });
            },
            submitStateFormatter(row){
                return row.submitState === '1' ? '已提交' : '未提交';
            },
            auditStateFormatter(row){
                let str = '';

                if(row.auditState==='1'){
                    str = '通过';
                }else if(row.auditState==='2'){
                    str = '驳回';
                }else{
                   if(row.submitState === '1'){
                       if(row.auditLevel === '1'){
                           str = '待审核';
                       }else{
                           str = '审核中';
                       }
                   }else{
                       str = '未提交';
                   }
                }

                return str;
            },
            handleCellStyle({row, column, rowIndex, columnIndex}){
                let cellStyle;

                if(columnIndex === 7){
                    switch (row.auditState) {
                        case '1':
                            cellStyle = 'color: #00FF40 !important;';
                            break;
                        case '2':
                            cellStyle = 'color: #FE2E2E !important;';
                            break;
                        default:
                            cellStyle = '';
                    }

                    return cellStyle;
                }
            },
            queryList() { //查询
                this.tableLoading = true;

                this.$api.scoreManage.graduateDesign.list({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = response.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            handleFilter() {
                this.queryForm.pageNum = 1;
                this.queryList();
            },
            handleReset() {
                this.queryForm.rowNum = 10;
                this.queryForm.pageNum = 1;
                this.queryForm.semesterCode = null;
                if(!this.stuAuthVisible){
                    this.queryForm.stuCode = null;
                    this.queryForm.stuName = null;
                }
                this.queryForm.className = null;
                this.queryForm.auditState = null;
                this.tableLoading = false;
                this.queryList();
            },
            handleSizeChange(val) {
                this.queryForm.rowNum = val;
                this.queryList();
            },
            handleCurrentChange(val) {
                this.queryForm.pageNum = val;
                this.queryList();
            },
            addRec() {
                this.operateAreaVisible = true;
                this.dialogTitle = '新建';
                this.dialogTop = '250px';
                this.dialogVisible = true;
                this.saveType = 'add';
                //this.curdForm.stuCode = '20215060010101';
                this.curdForm.stuCode = this.queryForm.stuCode;
            },
            editRec(rowData) {
                this.selectRowData = rowData;
                this.queryAttachmentList();

                this.dialogTitle = '编辑';
                this.dialogTop = '100px';
                this.dialogVisible = true;
                this.saveType = 'edit';

                this.$nextTick(() => {
                    this.curdForm.id = rowData.id;
                    this.curdForm.stuCode = rowData.stuCode;
                    this.curdForm.semesterCode = rowData.semesterCode;
                    this.curdForm.projectName = rowData.projectName;
                    this.curdForm.designDesc = rowData.designDesc;
                    this.curdForm.submitState = rowData.submitState;
                    this.operateAreaVisible = true;
                    this.attachmentVisible = true;
                    this.submitButtonVisible = true;
                });
            },
            saveRec() {
                this.formSubmiting = true;

                this.$refs.curdForm.validate((valid) => {
                    if (valid) {
                        this.$api.scoreManage.graduateDesign.saveRec({
                            data: this.curdForm,
                        }).then((response) => {
                            let state = response.data.data.state;

                            if (state == 'Success') {
                                showNotify('成功', '保存成功', 'success', 1500);

                                if(this.saveType == 'add'){
                                    this.dialogTop = '100px';
                                    this.attachmentVisible = true;
                                    this.submitButtonVisible = true;
                                    this.saveType = 'edit';
                                    this.selectRowData = response.data.data.rowData;
                                    this.curdForm.id = this.selectRowData.id;
                                    this.curdForm.submitState = this.selectRowData.submitState;
                                }else if(this.saveType == 'edit'){
                                    this.dialogVisible = false;
                                }

                                this.queryList();
                            }else{
                               showNotify('失败', '保存失败', 'error', 3000);
                            }
                        }).catch((error) => {
                            showNotify('错误', error, 'error', 3000);
                        });
                    } else {
                        return false;
                    }
                });

                this.formSubmiting = false;
            },
            submitRec(){
                confirmMsg('提交后将无法再修改毕业设计信息，是否继续？').then(() => {
                    this.curdForm.submitState = '1';
                    this.curdForm.auditState = '';
                    this.saveRec();
                });
            },
            delRec(rowData){
                confirmMsg('是否确定要删除毕业设计及相关附件信息？').then(() => {
                    this.$api.scoreManage.graduateDesign.delRec({
                        data: { id:rowData.id },
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            showNotify('成功', '删除成功', 'success', 1500);
                            this.queryList();
                        }else{
                           showNotify('失败', '删除失败', 'error', 3000);
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            showRec(rowData){
                this.selectRowData = rowData;
                this.queryAttachmentList();

                this.viewAreaVisible = true;
                this.attachmentVisible = true;
                this.dialogTitle = '详情';
                this.dialogTop = '100px';
                this.dialogVisible = true;
            },
            auditRec(rowData){
                this.selectRowData = rowData;
                this.queryAttachmentList();

                this.viewAreaVisible = true;
                this.attachmentVisible = true;
                this.auditAreaVisible = true;
                this.dialogTitle = '审核';
                this.dialogTop = '100px';
                this.dialogVisible = true;
            },
            auditCallback(auditInfo){
                this.dialogVisible = false;
                this.updateAuditState(auditInfo);
            },
            //完成审核后更新审核状态
            updateAuditState(auditInfo){
                this.$api.scoreManage.graduateDesign.updateAuditState({
                    data: auditInfo,
                }).then((response) => {
                    let state = response.data.data.state;
                    if(state == 'Success'){
                       this.queryList();
                    }else{
                        showNotify('失败', '审核状态更新失败', 'error', 3000);
                    }
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            closeDialog() {
                this.dialogVisible = false;
                this.operateAreaVisible = false;
                this.viewAreaVisible = false;
                this.attachmentVisible = false;
                this.auditAreaVisible = false;
                this.submitButtonVisible = false;
                this.$refs.curdForm.resetFields();
                this.fileTableData = [];
            },
            queryAttachmentList(){
                this.fileTableLoading = true;

                this.$api.scoreManage.graduateDesign.attachmentList({
                    data: { designCode:this.selectRowData.id },
                }).then((response) => {
                    this.fileTableData = response.data.data.list;
                    this.fileTableLoading = false;
                }).catch((error) => {
                    this.fileTableLoading = false;
                    console.log(error);
                });
            },
            //http-request上传方法（未使用）
            getFile(fileObj) {
                this.file = fileObj.file;
                //this.handleUpload(fileObj);
            },
            //当上传文件有变更时
            onChangeFile(file, fileList) {
                //文件类型限制
                let fileTypeArray = [];
                fileTypeArray.push('txt','doc','docx','xls','xlsx','pdf', 'ppt');//文本文件
                fileTypeArray.push('jpg','jpeg','png','gif');//图片
                fileTypeArray.push('mp3');//音频
                fileTypeArray.push('mp4');//视频
                let suffix = file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length).toLowerCase();
                //文件大小限制
                const sizeLimit = this.fileSizeLimit * 1024 * 1024;

                //判断文件类型及大小是否符合要求
                if (fileTypeArray.indexOf(suffix) < 0 || file.size > sizeLimit) {
                    this.$message({
                        message: '不符合要求的文件已自动过滤',
                        type: 'error'
                    });

                    let index = fileList.findIndex( fileItem => {
                        return fileItem.uid === file.uid
                    });
                    fileList.splice(index, 1); //从上传文件列表删除当前选中文件
                } else {
                    this.fileList = [];
                    this.fileList = fileList;
                }
            },
            //上传文件
            handleUpload() {
                /* let repeatFlag = false;
                for(let i=0; i<this.fileList.length; i++){
                    for(let j=0; j<this.fileTableData.length; j++){
                        if(this.fileList[i].name == this.fileTableData[j].fileName + '.' + this.fileTableData[j].fileType){
                            repeatFlag = true;
                        }
                    }
                }
                if(repeatFlag){
                    confirmMsg('存在相同名称的文件，上传将覆盖原文件，是否确定上传？').then(() => {
                        this.uploadFile();
                    });

                    return;
                } */

                if(this.fileList.length === 0){
                    this.$message({
                        message: '请先选择上传的文件',
                        type: 'warning'
                    });

                    return;
                }

                this.uploadFile();
            },
            uploadFile(){
                const loading = this.$loading({
                    lock: true,
                    text: '文件上传中，请稍候...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                //添加参数
                var formData = new FormData();
                for (let i=0; i<this.fileList.length; i++) {
                    formData.append("files", this.fileList[i].raw);
                }
                formData.append("designCode", this.selectRowData.id);

                this.$api.scoreManage.graduateDesign.uploadMultiFile({
                    data: formData,
                }).then(response => {
                    if (response.data.data.state == "Success") {
                        showNotify('成功', '上传成功', 'success', 1500);

                        this.uploadDialogVisible = false;
                        this.fileList = [];
                        this.$refs.uploadFile.clearFiles(); //把之前上传的清空
                        this.queryAttachmentList();
                    } else {
                        showNotify('失败', '上传失败', 'error', 3000);
                    }

                    loading.close();
                }).catch(error => {
                    showNotify('错误', error, 'error', 3000);
                    this.fileList = [];
                    this.$refs.uploadFile.clearFiles(); //把之前上传的清空
                    loading.close();
                });
            },
            handleRemove(file, fileList) {
                //console.log(file,fileList);
                this.fileList = [];
                this.fileList = fileList;
            },
            closeUploadDialog() {
                this.uploadDialogVisible = false;
                this.fileList = [];
                this.$refs.uploadFile.clearFiles();
            },
            handleExceed(files, fileList) {
                this.$message.warning(`每次上传限制最多选择10个文件`);
            },
            // 文件上传成功时的函数
            handleFilUploadSuccess(res, file, fileList) {
                // console.log(res, file, fileList)
                this.$message.success("上传成功")
            },
            confirmDelFile() {
                if (this.$refs.multipleTable.selection.length == 0) {
                    this.$message({
                        title: '提示',
                        message: '请选择要删除的附件！',
                        type: 'warning',
                        duration: 2000,
                    });
                    return;
                }

                confirmMsg('此操作将永久删除附件信息, 是否继续?').then(() => {
                    this.delFile();
                });
            },
            delFile(){
                let selectArray = this.$refs.multipleTable.selection;
                let selections = "";
                for (let i=0; i<selectArray.length; i++) {
                    selections += selectArray[i].id + ",";
                }
                if (selections.length > 0) {
                    selections = selections.substring(0, selections.length - 1);
                }

                this.$api.scoreManage.graduateDesign.delFile({
                    data: { id:selections }
                }).then(response => {
                    let state = response.data.data.state;

                    if (state == 'Success') {
                        showNotify('成功', '删除成功', 'success', 1500);
                        this.queryAttachmentList();
                    }else{
                        showNotify('失败', '删除成功', 'error', 3000);
                    }
                }).catch(error => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            showAttachment(rowData){
                this.fileInfo.name = rowData.fileName;
                this.fileInfo.type = rowData.fileType;
                this.fileInfo.url = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + rowData.previewPath;
                this.fileName = rowData.fileName + '.' + rowData.fileType;
                this.previewerVisible = true;
            },
            downloadAttachment(rowData){
                const fileUrl = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + rowData.filePath;
                let exist = this.isExistFile(fileUrl);
                if (exist) {
                    this.downloadFile(fileUrl, rowData.fileName+'.'+rowData.fileType);
                } else {
                    showNotify('错误', '文件不存在，如有疑问请联系管理员！', 'error', 3000);
                }
            },
            downloadFile(url, fileName) {
                let x = new XMLHttpRequest();
                x.open("GET", url, true);
                x.responseType = 'blob';
                x.onload = function(e) {
                    var url = window.URL.createObjectURL(x.response)
                    var a = document.createElement('a');
                    a.href = url
                    a.download = fileName;
                    a.click()
                }
                x.send();
            },
            isExistFile(url) {
                if (url == null || url == undefined || url == "") {
                    return false;
                }
                let xmlhttp;
                if (window.XMLHttpRequest) {
                    xmlhttp = new XMLHttpRequest();
                } else {
                    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                }
                xmlhttp.open("GET", url, false);
                xmlhttp.send();
                if (xmlhttp.readyState == 4) {
                    if (xmlhttp.status == 200) return true;
                    //url存在
                    else if (xmlhttp.status == 404) return false;
                    //url不存在
                    else return false; //其他状态
                }
            },
            showAuditList(rowData){
                this.curdForm.id = rowData.id;
                this.auditListDialogVisible = true;
            },
            handleRowClick(row){
                this.$refs.multipleTable.toggleRowSelection(row);
            },
        },
    }
</script>
<style scoped>
    .attachmentUpload /deep/ .el-upload-dragger {
        width: 480px;
        height: 250px;
    }
</style>



// WEBPACK FOOTER //
// graduateDesign.vue?75e55b08